export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8723.b32924e4.jpg";